/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

const entity = {
  uuid: {
    form: false,
    header: false
  },
  name: {
  },
  level: {
  }
}
const config = {
  load: async function () {
    return (await hillo.get('https://getMemberLevelList-evhwqutgjq-ey.a.run.app', {
      deviceId: await getCurrentDeviceId()
    })).data
  },
  add: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    return await hillo.jsonPost('https://createMemberLevel-evhwqutgjq-ey.a.run.app', {
      ...item
    })
  },
  edit: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    return await hillo.jsonPost('https://updateMemberLevel-evhwqutgjq-ey.a.run.app', {
      ...item
    })
  },
  remove: async function (uuid) {
    return await hillo.jsonPost('https://deleteMemberLevel-evhwqutgjq-ey.a.run.app', {
      deviceId: await getCurrentDeviceId(),
      uuid
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
